import Swiper from 'swiper';
import { Navigation, Keyboard } from 'swiper/modules';
import 'swiper/css';

export function homeCarousel() {
  new Swiper('.wp-block-home-carousel .swiper', {
    direction: 'horizontal',
    speed: 500,
    loop: true,
    spaceBetween: 8,
    slidesPerView: 1.1,
    breakpoints: {
      768: {
        spaceBetween: 30,
        slidesPerView: 1.5,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
    },
    on: {
      afterInit: (swiper) => {
        // Get the active slide and play its video
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeVideo = activeSlide.querySelector('video');

        if (activeVideo) {
          activeVideo.play();
        }
      },
      slideChangeTransitionStart: (swiper) => {
        // Get the active slide and play its video
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeVideo = activeSlide.querySelector('video');

        // Pause non-active videos and play new active video
        document.querySelectorAll('.swiper-slide video').forEach((video) => {
          if (activeVideo == video) {
            activeVideo.play();
          } else {
            video.pause();
          }
        });
      },
    },
    modules: [Navigation, Keyboard],
  });
}
